import { render, staticRenderFns } from "./roleAddOrUpdate.vue?vue&type=template&id=7033c8e9&scoped=true&"
import script from "./roleAddOrUpdate.vue?vue&type=script&lang=js&"
export * from "./roleAddOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7033c8e9",
  null
  
)

export default component.exports